(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8337,3282],{

/***/ 64821:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/back-arrow.e6d9293c.svg","height":19,"width":25});

/***/ }),

/***/ 1405:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/pdf-grey.950162d0.svg","height":23,"width":19});

/***/ }),

/***/ 71735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_ContactUs; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/lodash/startCase.js
var startCase = __webpack_require__(18029);
var startCase_default = /*#__PURE__*/__webpack_require__.n(startCase);
// EXTERNAL MODULE: ./node_modules/lodash/debounce.js
var debounce = __webpack_require__(23279);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./constants/config.js
var constants_config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./store/features/myProductSlice.js
var myProductSlice = __webpack_require__(3507);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
;// CONCATENATED MODULE: ./i18n/useContactUsi18n.js

const useContactUsi18n = (componentProps)=>{
    const { t  } = (0,esm/* useTranslation */.$G)();
    var ref, ref1;
    const i18n = {
        requiredInfoText: t("kf.auth.label.requiredFields"),
        contactUsDisplayName: t("kf.contactus.label.contactUsDisplayName"),
        contactUsDescription: t("kf.contactus.label.contactUsDescription"),
        installationQuestion: t("kf.contactus.label.installationQuestion"),
        yes: t("kf.contactus.label.yes"),
        no: t("kf.contactus.label.no"),
        howCanWeHelp: t("kf.contactus.label.howCanWeHelp"),
        aTopic: t("kf.contactus.label.aTopic"),
        installationDetails: t("kf.contactus.label.installationDetails"),
        selectProductType: t("kf.contactus.label.selectProductType"),
        serialNumber: t("kf.contactus.label.serialNumber"),
        modelNumber: t("kf.contactus.label.modelNumber"),
        whereToFind: t("kf.registerOfflineProduct.label.whereToFind"),
        kohler: t("kf.registerOfflineProduct.label.kohler"),
        sterlingProduct: t("kf.registerOfflineProduct.label.sterlingProduct"),
        yourorder: t("kf.registerOfflineProduct.label.yourorder"),
        productLabel: t("kf.registerOfflineProduct.label.productLabel"),
        productLiterature: t("kf.registerOfflineProduct.label.productLiterature"),
        invoice: t("kf.registerOfflineProduct.label.invoice"),
        stamped: t("kf.registerOfflineProduct.label.stamped"),
        troubleShooting: t("kf.registerOfflineProduct.label.troubleShooting"),
        findModelNumberQuestion: t("kf.contactus.label.findModelNumberQuestion"),
        placeOfPurchase: t("kf.contactus.label.placeOfPurchase"),
        placeOfPurchaseType: t("kf.contactus.label.placeOfPurchaseType"),
        monthOfInstallation: t("kf.contactus.label.monthOfInstallation"),
        yearOfInstallation: t("kf.contactus.label.yearOfInstallation"),
        contactInformation: t("kf.contactus.label.contactInformation"),
        companyName: t("kf.contactus.label.companyName"),
        homeowner: t("kf.contactus.label.homeowner"),
        professional: t("kf.contactus.label.professional"),
        fname: t("kf.contactus.label.firstName"),
        lname: t("kf.contactus.label.lastName"),
        email: t("kf.contactus.label.emailAddress"),
        cemail: t("kf.contactus.label.confirmEmailAddress"),
        businessType: t("kf.contactus.label.businessType"),
        typeOf: t("kf.contactus.label.typeOf"),
        address: t("kf.contactus.label.address"),
        aptFloorSuite: t("kf.contactus.label.aptFloorSuite"),
        city: t("kf.contactus.label.city"),
        state: t("kf.contactus.label.state"),
        zipcode: t("kf.contactus.label.zipCode"),
        country: t("kf.contactus.label.country"),
        phoneNumber: t("kf.contactus.label.phoneNumber"),
        workingWithProfessional: t("kf.contactus.label.workingWithProfessional"),
        nameOfTheCompany: t("kf.contactus.label.nameOfTheCompany"),
        describeYourRequest: t("kf.contactus.label.describeYourRequest"),
        requestDetail: t("kf.contactus.label.requestDetail"),
        messageLabel: t("kf.contactus.label.messageLabel"),
        uploadPhoto: t("kf.contactus.label.uploadPhoto"),
        uploadCountLimit: (componentProps === null || componentProps === void 0 ? void 0 : componentProps.errorMessage) || t("kf.contactus.label.uploadCountLimit"),
        uploadFileTypes: t("kf.contactus.label.uploadFileTypes"),
        uploadFileExtn: t("kf.contactus.label.uploadFileExtn"),
        uploadSizeLimit: t("kf.contactus.label.uploadSizeLimit"),
        uploadMBLimit: t("kf.contactus.label.uploadMBLimit"),
        dragAndDrop: t("kf.contactus.label.dragAndDrop"),
        orText: t("kf.contactus.label.orText"),
        uploadFileButton: t("kf.contactus.label.uploadFileButton"),
        submitButton: t("kf.contactus.label.submitButton"),
        privacyPolicy: t("kf.contactus.label.privacyPolicy"),
        subjectAccessRequest: t("kf.contactus.label.subjectAccessRequest"),
        termsOfService: t("kf.contactus.label.termsOfService"),
        backToContactUs: t("kf.contactus.label.backToContactUs"),
        messageSent: (ref = componentProps === null || componentProps === void 0 ? void 0 : componentProps.messageSent) !== null && ref !== void 0 ? ref : t("kf.contactus.label.messageSent"),
        responseReceiveTime: (ref1 = componentProps === null || componentProps === void 0 ? void 0 : componentProps.responseReceiveTime) !== null && ref1 !== void 0 ? ref1 : t("kf.contactus.label.responseReceiveTime"),
        continueShopping: t("kf.contactus.label.continueShopping"),
        fnameError: t("kf.contactus.error.fnameError"),
        lnameError: t("kf.contactus.error.lnameError"),
        noEmailError: t("kf.contactus.error.noEmailError"),
        validEmail: t("kf.contactus.error.validEmail"),
        confirmEmailError: t("kf.contactus.error.confirmEmailError"),
        emailMatchError: t("kf.contactus.error.emailMatchError"),
        noCompanyError: t("kf.contactus.error.noCompanyError"),
        businessTypeError: t("kf.contactus.error.businessTypeError"),
        subTypeError: t("kf.contactus.error.subTypeError"),
        addressError: t("kf.contactus.error.addressError"),
        cityError: t("kf.contactus.error.cityError"),
        stateError: t("kf.contactus.error.stateError"),
        zipcodeError: t("kf.contactus.error.zipcodeError"),
        validZipcode: t("kf.contactus.error.validZipcode"),
        cityStateZipMismatchError: t("kf.contactus.error.cityStateZipMismatchError"),
        countryError: t("kf.contactus.error.countryError"),
        validPhone: t("kf.contactus.error.validPhone"),
        noPhoneError: t("kf.contactus.error.noPhoneError"),
        fileLimitExceededError: t("kf.contactus.error.fileLimitExceededError"),
        protectedByGoogle: t("kf.contactus.message.protectedByGoogle"),
        productNumberError: t("kf.contactus.error.productNumberError"),
        apply: t("kf.global.label.apply"),
        errorFileType: t("kf.contactus.error.fileType"),
        errorMaxFileLimit: t("kf.contactus.error.maxFileLimit"),
        errorMaxFileSizeLimit: t("kf.contactus.error.maxFileSizeLimit"),
        installationDate: t("kf.contactus.label.installationDate"),
        installationDateValidError: t("kf.contactus.error.installationDateValidError"),
        serverError: t("kf.contactus.error.serverError"),
        businessAddress: t("kf.contactus.label.businessAddress"),
        businessPhone: t("kf.contactus.label.businessPhone"),
        home: t("kf.global.label.home"),
        helpTopic: t("kf.contactus.error.aTopic"),
        needHelp: t("kf.contactus.label.needHelp"),
        genError: t("kf.error.message.genericError"),
        emailIcon: t("kf.registration.label.email"),
        phone: t("kf.checkout.label.phone"),
        icon: t("kf.technical.label.icon"),
        ariaLabels: {
            imageRemove: t("kf.registerOfflineProduct.label.aria.removeImage")
        },
        commentBoxPlaceholder: t("kf.registerOfflineProduct.label.addComment"),
        productType: t("kf.contactus.error.productType"),
        validUSPhone: t("kf.checkout.error.validUSPhone"),
        fileUploaded: t("kf.contactus.label.fileUploaded")
    };
    return i18n;
};
/* harmony default export */ var i18n_useContactUsi18n = (useContactUsi18n);

// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./constants/api.js
var api = __webpack_require__(73350);
// EXTERNAL MODULE: ./js/helperV2.js
var helperV2 = __webpack_require__(30696);
// EXTERNAL MODULE: ./components/core/Button/Button.jsx + 1 modules
var Button = __webpack_require__(7872);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/ContactUs/v1/contactUsAnalytics.js
const getEventInfo = (type, link)=>{
    return JSON.stringify({
        clickInternalLinks: "true",
        eventAction: "support:contact:main content area:" + type,
        eventName: "support:contact:main content area:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "contact us",
        internalLinkType: "support:contact:navigation",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        internalLinkZoneName: "support:contact:main content area​"
    });
};
const getAnalyticsData = (analyticsData, label)=>{
    let jsonAnalyticsData = null;
    if (analyticsData) {
        jsonAnalyticsData = JSON.parse(analyticsData);
        Object.keys(jsonAnalyticsData).forEach((key)=>{
            if (jsonAnalyticsData[key]) {
                jsonAnalyticsData[key] = jsonAnalyticsData[key].replace("{?}", label === null || label === void 0 ? void 0 : label.toLowerCase());
            }
        });
    }
    return JSON.stringify(jsonAnalyticsData);
};
const analyticsOnDelete = (activeTabForAnalytics)=>{
    const eventInfo = {
        eventAction: "support:contact:form:".concat(activeTabForAnalytics, ":remove file"),
        eventName: "support:contact:form:".concat(activeTabForAnalytics, ":remove file"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "remove file",
        internalLinkPosition: "support:contact",
        internalLinkType: "support:contact:navigation",
        internalLinkZoneName: "support:contact:form",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo: eventInfo,
        page: page
    });
};

;// CONCATENATED MODULE: ./components/ContactUs/v1/FormTabs.jsx






const FormTabs = (props)=>{
    const { activeTab ="" , label =[] , changeActive =()=>{} , analyticsData ="" , i18n ={}  } = props;
    const tabRefs = (0,react.useRef)([]);
    const { CREATE_ACCOUNT_TYPE: { HOME_OWNER ="" , PROFESSIONAL =""  }  } = constants["default"];
    const HOME_OWNER_TAB = startCase_default()(HOME_OWNER);
    const PROFESSIONAL_TAB = startCase_default()(PROFESSIONAL);
    const handleKeyPress = (e, index)=>{
        const { keyCode: tabKeycode = ""  } = e;
        if (tabKeycode === 37 && activeTab === PROFESSIONAL_TAB) {
            var ref;
            changeActive(HOME_OWNER_TAB);
            (ref = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index - 1]) === null || ref === void 0 ? void 0 : ref.focus();
        } else if (tabKeycode === 39 && activeTab === HOME_OWNER_TAB) {
            var ref1;
            changeActive(PROFESSIONAL_TAB);
            (ref1 = tabRefs === null || tabRefs === void 0 ? void 0 : tabRefs.current[index + 1]) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tabs",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            id: "contactus-tab-list",
            className: "tab-list",
            role: "tablist",
            children: label === null || label === void 0 ? void 0 : label.map((l, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    ref: (el)=>tabRefs.current[index] = el,
                    id: "".concat(l, "-tab"),
                    role: "tab",
                    "aria-selected": activeTab === l,
                    tabIndex: activeTab === l ? 0 : -1,
                    className: classnames_default()({
                        "tab-list-item": true,
                        "tab-list-active": activeTab === l,
                        "gbh-data-layer": true
                    }),
                    onClick: ()=>changeActive(l),
                    onKeyDown: (e)=>handleKeyPress(e, index),
                    "data-gbh-data-layer": "".concat(getAnalyticsData(analyticsData, l)),
                    children: i18n["".concat(l.toLowerCase())]
                }, l))
        })
    });
};
/* harmony default export */ var v1_FormTabs = (FormTabs);

// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var dist_es = __webpack_require__(12002);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./public/icons/pdf-grey.svg
var pdf_grey = __webpack_require__(1405);
;// CONCATENATED MODULE: ./components/ContactUs/v1/UploadImage.jsx











const UploadImage = (props)=>{
    const dispatch = (0,es/* useDispatch */.I0)();
    const [errors, setErrors] = (0,react.useState)([]);
    const [status, setStatus] = (0,react.useState)("");
    const { imageList =[] , updateList =()=>{} , i18n ={} , activeTab ="" , buttonAnalyticsData =""  } = props;
    const activeTabForAnalytics = activeTab && (activeTab === null || activeTab === void 0 ? void 0 : activeTab.toLowerCase());
    const onDrop = async (acceptedFiles, rejectedFiles)=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        setStatus("");
        const errList = (ref = rejectedFiles[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.errors) === null || ref1 === void 0 ? void 0 : ref1.map((el)=>{
            return el === null || el === void 0 ? void 0 : el.message;
        });
        errList && setErrors(errList);
        if (!errList && (errors === null || errors === void 0 ? void 0 : errors.length) > 0) setErrors([]);
        if ((imageList === null || imageList === void 0 ? void 0 : imageList.length) + (acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.length) <= 5) {
            setErrors([]);
            try {
                const newImageList = await Promise.all(acceptedFiles === null || acceptedFiles === void 0 ? void 0 : acceptedFiles.map(async (f)=>{
                    const res = await dispatch((0,genericSlice/* uploadImage */.Ix)(f)).unwrap();
                    return Object.assign(f, {
                        preview: URL.createObjectURL(f),
                        comment: "",
                        link: res === null || res === void 0 ? void 0 : res.path,
                        textCount: 0
                    });
                }));
                updateList([
                    ...imageList,
                    ...newImageList
                ]);
                setStatus(i18n === null || i18n === void 0 ? void 0 : i18n.fileUploaded);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.log(err);
            }
        } else {
            setErrors([
                i18n === null || i18n === void 0 ? void 0 : i18n.uploadCountLimit
            ]);
        }
        if (((ref3 = (ref2 = rejectedFiles[0]) === null || ref2 === void 0 ? void 0 : ref2.errors[0]) === null || ref3 === void 0 ? void 0 : ref3.code) === "file-invalid-type") setErrors([
            i18n === null || i18n === void 0 ? void 0 : i18n.errorFileType
        ]);
        if ((rejectedFiles === null || rejectedFiles === void 0 ? void 0 : rejectedFiles.length) > 5) setErrors([
            i18n === null || i18n === void 0 ? void 0 : i18n.uploadCountLimit
        ]);
        if (((ref4 = rejectedFiles[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : ref5.size) > 5e6) setErrors([
            i18n === null || i18n === void 0 ? void 0 : i18n.errorMaxFileSizeLimit
        ]);
    };
    const validator = (file)=>{
        if ((file === null || file === void 0 ? void 0 : file.size) > 5e6) {
            return {
                message: i18n === null || i18n === void 0 ? void 0 : i18n.errorMaxFileSizeLimit
            };
        }
        switch(file === null || file === void 0 ? void 0 : file.type){
            case "image/jpeg":
            case "image/png":
            case "image/gif":
            case "application/pdf":
                break;
            default:
                return {
                    message: i18n === null || i18n === void 0 ? void 0 : i18n.errorFileType
                };
        }
    };
    const { getRootProps , getInputProps  } = (0,dist_es/* useDropzone */.uI)({
        accept: "image/png, image/jpg, image/jpeg, image/gif, application/pdf",
        maxFiles: 5,
        multiple: true,
        onDrop,
        validator
    });
    const onAddComment = (v, id)=>{
        const newList = imageList;
        newList[id]["comment"] = v;
        newList[id]["textCount"] = v === null || v === void 0 ? void 0 : v.length;
        updateList([
            ...newList
        ]);
    };
    const onDelete = (id)=>{
        var ref;
        const newList = imageList === null || imageList === void 0 ? void 0 : imageList.filter((l)=>l !== id);
        analyticsOnDelete(activeTabForAnalytics, id);
        updateList(newList);
        setStatus(i18n === null || i18n === void 0 ? void 0 : (ref = i18n.ariaLabels) === null || ref === void 0 ? void 0 : ref.imageRemove);
    };
    const handleFocus = (e)=>{
        const { currentTarget: { classList ={}  } = {}  } = e;
        classList === null || classList === void 0 ? void 0 : classList.add("active-comment");
    };
    const handleBlur = (e)=>{
        const { currentTarget: { classList ={}  } = {}  } = e;
        classList === null || classList === void 0 ? void 0 : classList.remove("active-comment");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "upload-image-container ".concat((imageList === null || imageList === void 0 ? void 0 : imageList.length) < 6 && (imageList === null || imageList === void 0 ? void 0 : imageList.length) !== 0 ? "file-5" : ""),
        id: "contact-image-preview-container",
        tabIndex: "0",
        role: "presentation",
        children: [
            imageList === null || imageList === void 0 ? void 0 : imageList.map((f, i)=>{
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    id: "input-id-active",
                    className: "contact-us-image-preview",
                    onClick: handleFocus,
                    onBlur: handleBlur,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "preview-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: classnames_default()({
                                    "image-box": (f === null || f === void 0 ? void 0 : f.type) !== "application/pdf"
                                }),
                                src: (f === null || f === void 0 ? void 0 : f.type) === "application/pdf" ? pdf_grey/* default */.Z === null || pdf_grey/* default */.Z === void 0 ? void 0 : pdf_grey/* default.src */.Z.src : f === null || f === void 0 ? void 0 : f.preview,
                                alt: f === null || f === void 0 ? void 0 : f.name
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                            id: "image-placeholder-".concat(i),
                            placeholder: i18n === null || i18n === void 0 ? void 0 : i18n.commentBoxPlaceholder,
                            value: f === null || f === void 0 ? void 0 : f.comment,
                            onChange: (e)=>onAddComment(e.target.value, i),
                            maxLength: 100
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            className: "text-count",
                            children: [
                                f === null || f === void 0 ? void 0 : f.textCount,
                                " / 100"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "image-delete",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                tabIndex: "0",
                                className: "custom-close-icone",
                                onClick: ()=>onDelete(f),
                                src: icons_close/* default */.Z === null || icons_close/* default */.Z === void 0 ? void 0 : icons_close/* default.src */.Z.src,
                                alt: "close"
                            })
                        })
                    ]
                }, i);
            }),
            (imageList === null || imageList === void 0 ? void 0 : imageList.length) !== 5 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "drag-and-drop-container",
                ...getRootProps(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ...getInputProps()
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "drag-and-drop-text-large",
                        children: i18n === null || i18n === void 0 ? void 0 : i18n.dragAndDrop
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "drag-and-drop-text-small",
                        children: i18n === null || i18n === void 0 ? void 0 : i18n.orText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "drag-and-drop-upload-btn",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            role: "button",
                            tabIndex: "-1",
                            className: buttonAnalyticsData ? "gbh-data-layer" : "",
                            "data-gbh-data-layer": buttonAnalyticsData || null,
                            type: "ghost",
                            label: i18n === null || i18n === void 0 ? void 0 : i18n.uploadFileButton,
                            disabled: (imageList === null || imageList === void 0 ? void 0 : imageList.length) === 5 && lib/* isMobile */.tq,
                            useDefaultClass: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                "aria-live": "polite",
                className: "aria-messages",
                children: status
            }),
            errors && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "upload-image-container__error-msg",
                children: errors[0]
            })
        ]
    });
};
/* harmony default export */ var v1_UploadImage = (UploadImage);

// EXTERNAL MODULE: ./public/icons/email.svg
var email = __webpack_require__(39306);
// EXTERNAL MODULE: ./public/icons/phone-icon.svg
var phone_icon = __webpack_require__(52324);
// EXTERNAL MODULE: ./components/core/Input/Input.jsx
var Input = __webpack_require__(3372);
// EXTERNAL MODULE: ./components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(77860);
// EXTERNAL MODULE: ./components/checkout/checkoutHelperFunction.js
var checkoutHelperFunction = __webpack_require__(37012);
;// CONCATENATED MODULE: ./components/ContactUs/v1/Form/ContactInfo.jsx
















const ContactInfo = (props)=>{
    var ref, ref1;
    const [suggestions, setSuggestions] = (0,react.useState)([]);
    const [countries, setCountries] = (0,react.useState)([]);
    const [stateList, setStateList] = (0,react.useState)([]);
    const [subTypeList, setSubTypeList] = (0,react.useState)([]);
    const [addressSelected, setAddressSelected] = (0,react.useState)(false);
    const [userInput, setUserInput] = (0,react.useState)({
        target: {
            value: "",
            id: ""
        }
    });
    const { activeTab ="" , data ={} , labels ={} , setData =()=>{} , error ={} , i18n ={} , setError =()=>{} , businessTypes =[] , onBlur =()=>{}  } = props;
    const { CREATE_ACCOUNT_TYPE: { HOME_OWNER ="" , PROFESSIONAL =""  }  } = constants["default"];
    const HOME_OWNER_TAB = startCase_default()(HOME_OWNER);
    const PROFESSIONAL_TAB = startCase_default()(PROFESSIONAL);
    const isMobile = window.innerWidth <= 480;
    const { countryListPath , stateListPath  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        setData({
            ...data,
            state: {}
        });
    }, [
        data === null || data === void 0 ? void 0 : data.country
    ]);
    (0,react.useEffect)(()=>{
        try {
            if (!isEmpty_default()(countryListPath) && !isEmpty_default()(stateListPath)) getLocations();
        } catch (error) {
            // eslint-disable-next-line no-console
            console.log(error);
        }
    }, [
        countryListPath,
        stateListPath
    ]);
    (0,react.useEffect)(()=>{
        if ((data === null || data === void 0 ? void 0 : data.address) && !addressSelected) getSuggestions(data === null || data === void 0 ? void 0 : data.address);
    }, [
        data === null || data === void 0 ? void 0 : data.address
    ]);
    const getLocations = async ()=>{
        if (countryListPath && stateListPath) {
            var ref, ref1;
            const countryData = await dispatch((0,genericSlice/* getCountryList */.Jp)());
            const stateData = await dispatch((0,genericSlice/* getstateList */.lK)());
            const mapList = !isEmpty_default()(countryData === null || countryData === void 0 ? void 0 : countryData.payload) && !isEmpty_default()(stateData === null || stateData === void 0 ? void 0 : stateData.payload) && (0,helper/* mapStateToCountryHandler */.oFy)(countryData === null || countryData === void 0 ? void 0 : countryData.payload, stateData === null || stateData === void 0 ? void 0 : stateData.payload) || [];
            setCountries(mapList);
            const config = await (0,constants_config/* getConfig */.i)();
            var ref2;
            const countryCode = (ref2 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.country) !== null && ref2 !== void 0 ? ref2 : "US";
            var ref3;
            setStateList((ref3 = (ref1 = mapList.find((c)=>{
                return (c === null || c === void 0 ? void 0 : c.code) === countryCode;
            })) === null || ref1 === void 0 ? void 0 : ref1.states) !== null && ref3 !== void 0 ? ref3 : []);
            var ref4;
            setData({
                ...data,
                country: (ref4 = mapList.find((country)=>{
                    return (country === null || country === void 0 ? void 0 : country.code) === countryCode;
                })) !== null && ref4 !== void 0 ? ref4 : {}
            });
        }
    };
    const getSuggestions = (0,react.useCallback)(debounce_default()((addr)=>{
        var ref;
        (ref = (0,checkoutHelperFunction/* getAddressSuggestions */.We)(addr)) === null || ref === void 0 ? void 0 : ref.then((suggData)=>setSuggestions(suggData));
    }, 300), [
        suggestions
    ]);
    const onSuggestionSelect = async (val)=>{
        const { general: { siteName  } = {}  } = await (0,constants_config/* getConfig */.i)();
        const addr = (0,helper/* destructureAddress */.LY3)(val, siteName);
        var ref;
        setData({
            ...data,
            address: addr === null || addr === void 0 ? void 0 : addr.address,
            city: addr === null || addr === void 0 ? void 0 : addr.city,
            state: (ref = stateList.find((s)=>{
                return (s === null || s === void 0 ? void 0 : s.code) === (addr === null || addr === void 0 ? void 0 : addr.state);
            })) !== null && ref !== void 0 ? ref : {},
            zipcode: addr === null || addr === void 0 ? void 0 : addr.zipcode
        });
        setError({
            ...error,
            address: false,
            city: false,
            state: false,
            zipcode: false
        });
        setSuggestions([]);
        setAddressSelected(true);
    };
    const onInputChange = (e)=>{
        const { target: { value ="" , id =""  } = {}  } = e;
        const field = id === null || id === void 0 ? void 0 : id.split("-");
        setData({
            ...data,
            [field[2]]: value
        });
        setError((prevError)=>({
                ...prevError,
                [field[2]]: null
            }));
        setAddressSelected(false);
    };
    const onNameChange = async (e)=>{
        const { target: { value ="" , id =""  } = {}  } = e;
        const field = id === null || id === void 0 ? void 0 : id.split("-");
        if (value === "" || await (0,helper/* validateField */.OP$)("name", value)) {
            setData({
                ...data,
                [field[2]]: value
            });
            setError((prevError)=>({
                    ...prevError,
                    [field[2]]: null
                }));
        }
    };
    const changeCountry = (country)=>{
        var ref;
        var ref1;
        setStateList((ref1 = (ref = countries === null || countries === void 0 ? void 0 : countries.find((c)=>{
            return (c === null || c === void 0 ? void 0 : c.name) === country;
        })) === null || ref === void 0 ? void 0 : ref.states) !== null && ref1 !== void 0 ? ref1 : []);
        setData({
            ...data,
            country: countries === null || countries === void 0 ? void 0 : countries.find((c)=>{
                return (c === null || c === void 0 ? void 0 : c.name) === country;
            })
        });
    };
    const changeState = (state)=>{
        var ref;
        setData({
            ...data,
            state: (ref = {
                code: state
            }) !== null && ref !== void 0 ? ref : {}
        });
        setError({
            ...error,
            state: false
        });
    };
    const selectBusinessType = (businessType)=>{
        var ref, ref1, ref2;
        setData({
            ...data,
            businessType,
            subType: ""
        });
        const subTypeL = (ref2 = (ref = businessTypes === null || businessTypes === void 0 ? void 0 : businessTypes.find((el)=>{
            return (el === null || el === void 0 ? void 0 : el.text) === businessType;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.split(",")) === null || ref2 === void 0 ? void 0 : ref2.filter((e)=>e);
        setSubTypeList(subTypeL);
        setError({
            ...error,
            businessType: false
        });
    };
    const selectSubType = (subType)=>{
        setData({
            ...data,
            subType
        });
        setError({
            ...error,
            subType: false
        });
    };
    const handleContactUserCompany = (e)=>{
        const { target: { value ="" , id =""  } = {}  } = e;
        setUserInput({
            target: {
                value: value,
                id: id
            }
        });
    };
    const handleContactUserCompanyValidation = async ()=>{
        var ref;
        const userInputValue = userInput === null || userInput === void 0 ? void 0 : (ref = userInput.target) === null || ref === void 0 ? void 0 : ref.value;
        if (await (0,helper/* validateField */.OP$)("contactusCompanyName", userInputValue) || userInputValue === "") {
            onInputChange(userInput);
        }
    };
    (0,react.useEffect)(()=>{
        handleContactUserCompanyValidation();
    }, [
        userInput
    ]);
    var ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container mb-40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pl-0 ".concat(isMobile ? "pr-0" : "pr-10"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-fname",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.fname,
                            maxLength: 40,
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.fname, "*"),
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.fname, "*"),
                            onChange: onNameChange,
                            showError: error === null || error === void 0 ? void 0 : error.fname,
                            errorMessage: error === null || error === void 0 ? void 0 : error.fname,
                            onBlur: ()=>onBlur("fname")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pr-0 ".concat(isMobile ? "pl-0" : "pl-10"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-lname",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.lname,
                            maxLength: 40,
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.lname, "*"),
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.lname, "*"),
                            onChange: onNameChange,
                            showError: error === null || error === void 0 ? void 0 : error.lname,
                            errorMessage: error === null || error === void 0 ? void 0 : error.lname,
                            onBlur: ()=>onBlur("lname")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-email",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.email,
                            maxLength: 60,
                            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: email/* default */.Z === null || email/* default */.Z === void 0 ? void 0 : email/* default.src */.Z.src,
                                alt: "",
                                "aria-hidden": "true"
                            }),
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.email, "*"),
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.email, "*"),
                            onChange: onInputChange,
                            showError: error === null || error === void 0 ? void 0 : error.email,
                            errorMessage: error === null || error === void 0 ? void 0 : error.email,
                            onBlur: ()=>onBlur("email")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-cemail",
                            type: "text",
                            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: email/* default */.Z === null || email/* default */.Z === void 0 ? void 0 : email/* default.src */.Z.src,
                                alt: "",
                                "aria-hidden": "true"
                            }),
                            value: data === null || data === void 0 ? void 0 : data.cemail,
                            maxLength: 60,
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.cemail, "*"),
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.cemail, "*"),
                            onChange: onInputChange,
                            showError: error === null || error === void 0 ? void 0 : error.cemail,
                            errorMessage: error === null || error === void 0 ? void 0 : error.cemail,
                            onBlur: ()=>onBlur("cemail")
                        })
                    })
                ]
            }),
            activeTab === PROFESSIONAL_TAB && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-company",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.company,
                            maxLength: 50,
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.companyName, "*"),
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.companyName, "*"),
                            onChange: handleContactUserCompany,
                            showError: error === null || error === void 0 ? void 0 : error.company,
                            errorMessage: error === null || error === void 0 ? void 0 : error.company,
                            onBlur: ()=>onBlur("company")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                            id: "contact-form-businessType",
                            customClass: "input-field",
                            data: businessTypes.map((el)=>{
                                return el === null || el === void 0 ? void 0 : el.text;
                            }),
                            value: data === null || data === void 0 ? void 0 : data.businessType,
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.businessType, "*"),
                            onChange: selectBusinessType,
                            showError: error === null || error === void 0 ? void 0 : error.businessType,
                            errorMessage: error === null || error === void 0 ? void 0 : error.businessType,
                            onBlur: ()=>onBlur("businessType")
                        })
                    }),
                    (data === null || data === void 0 ? void 0 : data.businessType) && (subTypeList === null || subTypeList === void 0 ? void 0 : subTypeList.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 px-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                            id: "contact-form-subType",
                            customClass: "input-field",
                            data: subTypeList,
                            value: data === null || data === void 0 ? void 0 : data.subType,
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.typeOf).concat(data === null || data === void 0 ? void 0 : data.businessType, "*"),
                            onChange: selectSubType,
                            showError: error === null || error === void 0 ? void 0 : error.subType,
                            errorMessage: error === null || error === void 0 ? void 0 : error.subType,
                            onBlur: ()=>onBlur("subType")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-md-12 col-lg-9 pl-0 pr-10 mobile-pr-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-address",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.address,
                            placeholder: "".concat(activeTab === HOME_OWNER_TAB ? i18n === null || i18n === void 0 ? void 0 : i18n.address : i18n === null || i18n === void 0 ? void 0 : i18n.businessAddress, "*"),
                            label: "".concat(activeTab === HOME_OWNER_TAB ? i18n === null || i18n === void 0 ? void 0 : i18n.address : i18n === null || i18n === void 0 ? void 0 : i18n.businessAddress, "*"),
                            onChange: onInputChange,
                            showError: error === null || error === void 0 ? void 0 : error.address,
                            errorMessage: error === null || error === void 0 ? void 0 : error.address,
                            suggestions: suggestions,
                            onSelect: onSuggestionSelect,
                            onBlur: ()=>onBlur("address"),
                            autoComplete: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-md-12 col-lg-3 col-sm-12 pr-0 pl-10 mobile-pl-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-aptFloor",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.aptFloor,
                            autoComplete: true,
                            placeholder: i18n === null || i18n === void 0 ? void 0 : i18n.aptFloorSuite,
                            label: i18n === null || i18n === void 0 ? void 0 : i18n.aptFloorSuite,
                            onChange: onInputChange
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-md-12 col-lg-6 pl-0 pr-10 mobile-pr-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-city",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.city,
                            autoComplete: true,
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.city, "*"),
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.city, "*"),
                            onChange: onInputChange,
                            showError: error === null || error === void 0 ? void 0 : error.city,
                            errorMessage: error === null || error === void 0 ? void 0 : error.city,
                            onBlur: ()=>onBlur("city")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-6 col-md-6 col-lg-3 pr-10 pl-10 mobile-pl-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                            id: "contact-user-state",
                            data: stateList !== null && stateList !== void 0 ? stateList : [],
                            value: (ref2 = data === null || data === void 0 ? void 0 : (ref = data.state) === null || ref === void 0 ? void 0 : ref.code) !== null && ref2 !== void 0 ? ref2 : "",
                            label: "".concat(labels && labels.stateLabel ? labels.stateLabel : i18n === null || i18n === void 0 ? void 0 : i18n.state, "*"),
                            onChange: changeState,
                            showError: error === null || error === void 0 ? void 0 : error.state,
                            errorMessage: error === null || error === void 0 ? void 0 : error.state,
                            onBlur: ()=>onBlur("state"),
                            ariaStateText: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-6 col-md-6 col-lg-3 pr-0 pl-10 mobile-pr-0 mobile-pl-10",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-zipcode",
                            type: "text",
                            value: data === null || data === void 0 ? void 0 : data.zipcode,
                            maxLength: 7,
                            autoComplete: true,
                            placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.zipcode, "*"),
                            label: "".concat(labels && labels.zipCodeLabel ? labels.zipCodeLabel : i18n === null || i18n === void 0 ? void 0 : i18n.zipcode, "*"),
                            onChange: onInputChange,
                            showError: error === null || error === void 0 ? void 0 : error.zipcode,
                            errorMessage: error === null || error === void 0 ? void 0 : error.zipcode,
                            onBlur: ()=>onBlur("zipcode")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row mx-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pl-0 ".concat(isMobile ? "pr-0" : "pr-10", " mb-20"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                            id: "contact-user-country",
                            data: countries.map((country)=>{
                                return country === null || country === void 0 ? void 0 : country.name;
                            }),
                            name: "country",
                            value: (ref3 = data === null || data === void 0 ? void 0 : (ref1 = data.country) === null || ref1 === void 0 ? void 0 : ref1.name) !== null && ref3 !== void 0 ? ref3 : "",
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.country),
                            onChange: changeCountry,
                            showError: error === null || error === void 0 ? void 0 : error.country,
                            errorMessage: error === null || error === void 0 ? void 0 : error.country
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 col-sm-6 col-md-6 pr-0 ".concat(isMobile ? "pl-0" : "pl-10"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                            id: "contact-user-phone",
                            type: "text",
                            maxLength: 14,
                            placeholder: "".concat(activeTab === HOME_OWNER_TAB ? i18n === null || i18n === void 0 ? void 0 : i18n.phoneNumber : i18n === null || i18n === void 0 ? void 0 : i18n.businessPhone, "*"),
                            label: "".concat(activeTab === HOME_OWNER_TAB ? i18n === null || i18n === void 0 ? void 0 : i18n.phoneNumber : i18n === null || i18n === void 0 ? void 0 : i18n.businessPhone, "*"),
                            prefix: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: phone_icon/* default */.Z === null || phone_icon/* default */.Z === void 0 ? void 0 : phone_icon/* default.src */.Z.src,
                                alt: "",
                                "aria-hidden": "true"
                            }),
                            value: data === null || data === void 0 ? void 0 : data.phone,
                            onChange: (e)=>{
                                setData({
                                    ...data,
                                    phone: (0,helperV2/* convertToUSPhoneNumber */.o8)(e.target.value)
                                });
                            },
                            showError: error === null || error === void 0 ? void 0 : error.phone,
                            errorMessage: error === null || error === void 0 ? void 0 : error.phone,
                            onBlur: ()=>onBlur("phone")
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Form_ContactInfo = (ContactInfo);

// EXTERNAL MODULE: ./utils/dateHelper.js + 40 modules
var dateHelper = __webpack_require__(64443);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
// EXTERNAL MODULE: ./node_modules/date-fns/locale/fr.mjs + 5 modules
var fr = __webpack_require__(58594);
// EXTERNAL MODULE: ./components/core/RadioButton/RadioButton.jsx
var RadioButton = __webpack_require__(65131);
;// CONCATENATED MODULE: ./components/ContactUs/v1/Form/contactUsFormAnalytics.js

const addDropdownAnalytics = (val)=>{
    const eventInfo = contactUsFormAnalytics_getEventInfo("how can we help you", false, true, val);
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo,
        page
    });
};
const contactUsFormAnalytics_getEventInfo = function(value) {
    let needJson = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, interLinkTypeSameAsVal = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, internalLinkNameVal = arguments.length > 3 ? arguments[3] : void 0;
    const internalLinkType = interLinkTypeSameAsVal ? "support:contact:".concat(value) : "support:contact:navigation";
    const internalLinkName = internalLinkNameVal ? internalLinkNameVal : value;
    const eventInfo = {
        eventAction: "support:contact:form:".concat(value),
        eventName: "support:contact:form:".concat(value),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName,
        internalLinkPosition: "contact us",
        internalLinkType,
        internalLinkZoneName: "support:contact:form",
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (needJson) return JSON.stringify(eventInfo);
    return eventInfo;
};
const analyticsOnFindMyProduct = function(authorData) {
    let interLinkTypeSameAsVal = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, internalLinkNameVal = arguments.length > 2 ? arguments[2] : void 0;
    const { linkText , link  } = authorData;
    const eventInfo = {
        eventAction: "".concat(constants.CONTACT_US_SUPPORT, ":").concat(linkText.toLowerCase().trim()),
        eventName: "".concat(constants.CONTACT_US_SUPPORT, ":").concat(linkText.toLowerCase().trim()),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: internalLinkNameVal ? internalLinkNameVal : linkText.toLowerCase().trim(),
        internalLinkPosition: "contact us",
        internalLinkType: interLinkTypeSameAsVal ? "".concat(constants.CONTACT_US_FORM, ":").concat(linkText.toLowerCase().trim()) : "".concat(constants.CONTACT_US_FORM, ":navigation"),
        internalLinkZoneName: constants.CONTACT_US_SUPPORT,
        internalLinkURL: window.origin + link,
        clickInternalLinks: "true"
    };
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo: eventInfo,
        page: page
    });
};

// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-core/esm/Inputs/DateInput/DateInput.mjs + 12 modules
var DateInput = __webpack_require__(81360);
// EXTERNAL MODULE: ./node_modules/@kohler-dsm-library/kohler-icons/esm/CalendarIcon.mjs
var CalendarIcon = __webpack_require__(3238);
// EXTERNAL MODULE: ./node_modules/dayjs/locale/fr-ca.js
var fr_ca = __webpack_require__(77989);
;// CONCATENATED MODULE: ./components/ContactUs/v1/Form/ProductInstalled.jsx
















const ProductInstalled = (props)=>{
    var ref;
    const [userInput, setUserInput] = (0,react.useState)({
        target: {
            value: "",
            id: ""
        }
    });
    const { data ={} , setData =()=>{} , error ={} , i18n ={} , radioKeyDown =()=>{} , setError =()=>{} , authorData ={} , getModelNumberSuggestions =()=>{} , helpTopic =[] , onBlur =()=>{} , productTypes =[] , modelSuggestions =[] , onSuggestionSelect =()=>{} , invalidModelNumber =false , placeOfPurchase =[]  } = props;
    const localeLanguage = (0,esm/* useTranslation */.$G)();
    if ((localeLanguage === null || localeLanguage === void 0 ? void 0 : (ref = localeLanguage.i18n) === null || ref === void 0 ? void 0 : ref.language) === "fr") {
        fr.fr.options.weekStartsOn = 0;
        (0,react_datepicker_min.registerLocale)("fr", fr.fr);
    }
    const onInputChange = (e)=>{
        const { target: { value ="" , id =""  } = {}  } = e;
        const field = id === null || id === void 0 ? void 0 : id.split("-");
        setData({
            ...data,
            [field[2]]: value
        });
    };
    const handleModelNumberValidation = async ()=>{
        var ref;
        const userInputValue = userInput === null || userInput === void 0 ? void 0 : (ref = userInput.target) === null || ref === void 0 ? void 0 : ref.value;
        if (await (0,helper/* validateField */.OP$)("modelNumber", userInputValue) || userInputValue === "") {
            onInputChange(userInput);
            if ((userInputValue === null || userInputValue === void 0 ? void 0 : userInputValue.length) > 2) {
                getModelNumberSuggestions(userInputValue);
            }
        }
    };
    (0,react.useEffect)(()=>{
        handleModelNumberValidation();
    }, [
        userInput
    ]);
    const handleModelNumber = (e)=>{
        const { target: { value ="" , id =""  } = {}  } = e;
        setUserInput({
            target: {
                value: value,
                id: id
            }
        });
    };
    const changeDateFormat = (date)=>{
        if (date) {
            const dateVal = (0,dateHelper/* formatDate */.p6)(date, "yyyy-MM-dd");
            setData({
                ...data,
                installDate: dateVal
            });
            setError({});
        }
    };
    const handleProductType = (productType)=>{
        setData({
            ...data,
            productType
        });
        setError({
            ...error,
            productType: false
        });
    };
    const { globalConfig  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { internationalization: { locale =""  } = {}  } = globalConfig;
    const newLocale = (locale === null || locale === void 0 ? void 0 : locale.includes("fr-CA")) ? "fr-ca" : (locale === null || locale === void 0 ? void 0 : locale.includes("en-CA")) ? "en-ca" : "en";
    const datePickerProps = {
        id: "contact-installed-installDate",
        mod: "white",
        firstDayOfWeek: 0,
        value: (data === null || data === void 0 ? void 0 : data.installDate) ? new Date(data.installDate) : null,
        onBlur: props.onBlur,
        popoverProps: {
            position: "bottom-start"
        },
        onChange: (date)=>changeDateFormat(date),
        leftIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarIcon/* CalendarIcon */.Q, {}),
        inputProps: {
            onBlur: ()=>{
                var ref;
                return props === null || props === void 0 ? void 0 : (ref = props.onBlur) === null || ref === void 0 ? void 0 : ref.call(props, "installDate");
            }
        },
        wrapperProps: {
            width: "297.6px"
        },
        minDate: new Date("01/01/2001"),
        maxDate: new Date(),
        label: i18n === null || i18n === void 0 ? void 0 : i18n.installationDate,
        placeholder: "MM/DD/YYYY",
        valueFormat: "MM/DD/YYYY",
        focusOutsideMonthDays: true,
        locale: newLocale
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "optional-form",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                role: "radiogroup",
                "aria-labelledby": "installed-radio",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        id: "installed-radio",
                        className: "question",
                        children: i18n === null || i18n === void 0 ? void 0 : i18n.needHelp
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "radio-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                id: "installed",
                                name: "installed",
                                value: i18n === null || i18n === void 0 ? void 0 : i18n.yes,
                                checked: data === null || data === void 0 ? void 0 : data.active,
                                analyticsData: contactUsFormAnalytics_getEventInfo("yes"),
                                onClick: ()=>setData({
                                        ...data,
                                        active: true
                                    }),
                                onKeydown: radioKeyDown
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                id: "not-installed",
                                name: "installed",
                                value: i18n === null || i18n === void 0 ? void 0 : i18n.no,
                                checked: !(data === null || data === void 0 ? void 0 : data.active),
                                analyticsData: contactUsFormAnalytics_getEventInfo("no"),
                                onClick: ()=>setData({
                                        ...data,
                                        active: false
                                    }),
                                onKeydown: radioKeyDown
                            })
                        ]
                    })
                ]
            }),
            !(data === null || data === void 0 ? void 0 : data.active) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "form-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                    id: "contact-installed-helpTopic",
                    data: helpTopic,
                    value: data === null || data === void 0 ? void 0 : data.helpTopic,
                    label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.howCanWeHelp, "*"),
                    onChange: (helpTopic)=>{
                        addDropdownAnalytics(helpTopic === null || helpTopic === void 0 ? void 0 : helpTopic.toLowerCase());
                        setData({
                            ...data,
                            helpTopic
                        });
                        setError({
                            ...error,
                            helpTopic: false
                        });
                    },
                    onBlur: ()=>onBlur("helpTopic"),
                    showError: error === null || error === void 0 ? void 0 : error.helpTopic,
                    errorMessage: error === null || error === void 0 ? void 0 : error.helpTopic
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "form-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                        id: "contact-installed-productTypes",
                        customClass: "input-field",
                        data: productTypes,
                        value: data === null || data === void 0 ? void 0 : data.productType,
                        label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.selectProductType, "*"),
                        onChange: (productType)=>handleProductType(productType),
                        showError: error === null || error === void 0 ? void 0 : error.productType,
                        onBlur: ()=>onBlur("productType"),
                        errorMessage: error === null || error === void 0 ? void 0 : error.productType
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "contact-installed-modelNumber",
                        type: "text",
                        value: data === null || data === void 0 ? void 0 : data.modelNumber,
                        maxLength: 40,
                        placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.modelNumber),
                        label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.modelNumber),
                        onChange: handleModelNumber,
                        suggestions: modelSuggestions,
                        onSelect: (val)=>onSuggestionSelect(val),
                        showError: invalidModelNumber,
                        errorMessage: i18n === null || i18n === void 0 ? void 0 : i18n.productNumberError
                    }),
                    (authorData === null || authorData === void 0 ? void 0 : authorData.linkText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: authorData === null || authorData === void 0 ? void 0 : authorData.link,
                        className: "modal-link",
                        onClick: ()=>analyticsOnFindMyProduct(authorData),
                        role: "link",
                        tabIndex: "0",
                        target: (authorData === null || authorData === void 0 ? void 0 : authorData.linkToNewTab) ? "_blank" : "_self",
                        rel: "noreferrer",
                        children: authorData === null || authorData === void 0 ? void 0 : authorData.linkText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                        id: "contact-installed-serial",
                        type: "text",
                        value: data === null || data === void 0 ? void 0 : data.serial,
                        maxLength: 40,
                        placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.serialNumber),
                        label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.serialNumber),
                        onChange: (e)=>{
                            const { value  } = e.target;
                            if ((0,helper/* checkAlphanumeric */.ytv)(value) || value === "") {
                                onInputChange(e);
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-20",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                            id: "contact-installed-purchase",
                            data: placeOfPurchase,
                            value: data === null || data === void 0 ? void 0 : data.purchase,
                            label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.placeOfPurchaseType),
                            onBlur: onBlur,
                            onChange: (purchase)=>setData({
                                    ...data,
                                    purchase
                                })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "kf-react-datepicker",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateInput/* DateInput */.W, {
                                ...datePickerProps
                            }),
                            " "
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Form_ProductInstalled = (ProductInstalled);

;// CONCATENATED MODULE: ./components/ContactUs/v1/Form/WithProfessional.jsx





const WithProfessional = (props)=>{
    const { i18n ={} , data ={} , setData =()=>{} , radioKeyDown =()=>{}  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "optional-form border-0",
        role: "radiogroup",
        "aria-labelledby": "with-professional-radio",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                id: "with-professional-radio",
                className: "question",
                children: i18n === null || i18n === void 0 ? void 0 : i18n.workingWithProfessional
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "radio-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                        id: "with-professional",
                        name: "with-professional",
                        value: i18n === null || i18n === void 0 ? void 0 : i18n.yes,
                        checked: data === null || data === void 0 ? void 0 : data.active,
                        onClick: ()=>setData({
                                active: true
                            }),
                        onKeydown: radioKeyDown
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                        id: "without-professional",
                        name: "with-professional",
                        value: i18n === null || i18n === void 0 ? void 0 : i18n.no,
                        checked: !(data === null || data === void 0 ? void 0 : data.active),
                        onClick: ()=>setData({
                                active: false
                            }),
                        onKeydown: radioKeyDown
                    })
                ]
            }),
            (data === null || data === void 0 ? void 0 : data.active) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "form-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                    id: "kf-professional-company",
                    type: "text",
                    value: (data === null || data === void 0 ? void 0 : data.company) || "",
                    maxLength: 50,
                    placeholder: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.companyName),
                    label: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.companyName),
                    onChange: async (e)=>{
                        const { value  } = e.target;
                        if (await (0,helper/* validateField */.OP$)("contactusCompanyName", value) || value === "") {
                            setData({
                                ...data,
                                company: value
                            });
                        }
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var Form_WithProfessional = (WithProfessional);

// EXTERNAL MODULE: ./public/icons/back-arrow.svg
var back_arrow = __webpack_require__(64821);
;// CONCATENATED MODULE: ./components/ContactUs/v1/ContactUsConfirmation.jsx







const ContactUsConfirmation = (props)=>{
    const { setSubmitSuccess =()=>{} , i18n ={} , continueShoppingUrl =""  } = props;
    const successMessageRef = (0,react.useRef)(null);
    (0,react.useEffect)(()=>{
        var ref;
        successMessageRef === null || successMessageRef === void 0 ? void 0 : (ref = successMessageRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        window === null || window === void 0 ? void 0 : window.scroll({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "kf-react-container",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "contact-us__success-message",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "back gbh-data-layer",
                    "data-gbh-data-layer": getEventInfo("back to contact us"),
                    onClick: ()=>setSubmitSuccess(false),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: back_arrow/* default */.Z === null || back_arrow/* default */.Z === void 0 ? void 0 : back_arrow/* default.src */.Z.src,
                            alt: "Back"
                        }),
                        i18n === null || i18n === void 0 ? void 0 : i18n.backToContactUs
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    ref: successMessageRef,
                    id: "contact-us-success-message",
                    className: "message-content",
                    tabIndex: "0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "title",
                            children: i18n === null || i18n === void 0 ? void 0 : i18n.messageSent
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "details",
                            children: (0,helper/* sanitizeInnerHtml */.KD0)(i18n === null || i18n === void 0 ? void 0 : i18n.responseReceiveTime)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    type: "black",
                    label: i18n === null || i18n === void 0 ? void 0 : i18n.continueShopping,
                    to: continueShoppingUrl,
                    className: "gbh-data-layer contact-us__continue-shopping-btn",
                    "data-gbh-data-layer": getEventInfo("continue shopping", continueShoppingUrl),
                    useDefaultClass: true
                })
            ]
        })
    });
};
/* harmony default export */ var v1_ContactUsConfirmation = ((0,lib/* withOrientationChange */.Qe)(ContactUsConfirmation));

// EXTERNAL MODULE: ./components/core/ReCaptcha/ReCaptcha.jsx + 1 modules
var ReCaptcha = __webpack_require__(46394);
// EXTERNAL MODULE: ./components/ContactUs/v1/ContactUsView/index.module.scss
var index_module = __webpack_require__(32979);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/core/TextArea/index.module.scss
var TextArea_index_module = __webpack_require__(81770);
var TextArea_index_module_default = /*#__PURE__*/__webpack_require__.n(TextArea_index_module);
;// CONCATENATED MODULE: ./components/ContactUs/v1/ContactUsView/contactUsViewAnalytics.js
const contactUsViewAnalytics_getAnalyticsData = (activeTab, formError, submitSuccess, isForSubButton, formErrorFromServer, isSuccessStatus)=>{
    const internalLinkType = isForSubButton ? "support:contact:submit" : "support:contact:navigation";
    const eventType = isForSubButton ? "submit" : "upload file";
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "support:contact:form:".concat(activeTab === null || activeTab === void 0 ? void 0 : activeTab.toLowerCase(), ":").concat(eventType),
        eventMsg: isForSubButton ? formErrorFromServer || formError || "n/a" : "n/a",
        eventName: "support:contact:form:".concat(activeTab === null || activeTab === void 0 ? void 0 : activeTab.toLowerCase(), ":").concat(eventType),
        eventStatus: isForSubButton ? submitSuccess || isSuccessStatus ? "success" : "failure" : "n/a",
        eventType: "navigation",
        internalLinkName: eventType,
        internalLinkPosition: "contact us",
        internalLinkType,
        internalLinkURL: "n/a",
        internalLinkZoneName: "support:contact:form"
    };
    return JSON.stringify(eventInfo);
};
const addFormAnalyticsData = (activeTab, submitSuccess, formError, isSuccessStatus)=>{
    const { adobeDataLayer: { getState  } = {}  } = window;
    const page = getState && getState("page") || {};
    const eventInfo = contactUsViewAnalytics_getAnalyticsData(activeTab, formError, submitSuccess, true, formError, isSuccessStatus);
    window.adobeDataLayer.push({
        event: "cmp:click",
        eventInfo: JSON.parse(eventInfo),
        page: page
    });
};
const getFooterEventInfo = function(type, link) {
    let clickInternalLinks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "true";
    return JSON.stringify({
        eventAction: "support:contact:form:footer:" + type,
        eventName: "support:contact:form:footer:" + type,
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: type,
        internalLinkPosition: "contact us",
        internalLinkType: "support:contact:navigation",
        internalLinkZoneName: "support:contact:form:footer",
        internalLinkURL: link ? (link.indexOf("http") === -1 ? window.location.origin : "") + link : "n/a",
        clickInternalLinks
    });
};
const getRecaptchaAnalytics = {
    pageTitle: "support:contact",
    internalLinkPosition: "contact us",
    internalLinkType: "support:contact:navigation"
};

// EXTERNAL MODULE: ./i18n/useSearchi18n.js
var useSearchi18n = __webpack_require__(81294);
;// CONCATENATED MODULE: ./components/ContactUs/v1/ContactUsView/index.jsx






















const ContactUs = (props)=>{
    const [error, setError] = (0,react.useState)({});
    const [userData, setUserData] = (0,react.useState)({
        fname: "",
        lname: "",
        email: "",
        cemail: "",
        address: "",
        aptFloor: "",
        city: "",
        state: {},
        zipcode: "",
        country: {},
        phone: "",
        company: "",
        businessType: "",
        subType: ""
    });
    const [homeOwnerData, setHomeOwnerData] = (0,react.useState)({
        fname: "",
        lname: "",
        email: "",
        cemail: "",
        address: "",
        aptFloor: "",
        city: "",
        state: {},
        zipcode: "",
        country: {},
        phone: "",
        company: "",
        businessType: "",
        subType: ""
    });
    const [professionalData, setProfessionalData] = (0,react.useState)({
        fname: "",
        lname: "",
        email: "",
        cemail: "",
        address: "",
        aptFloor: "",
        city: "",
        state: {},
        zipcode: "",
        country: {},
        phone: "",
        company: "",
        businessType: "",
        subType: ""
    });
    const { CREATE_ACCOUNT_TYPE: { HOME_OWNER ="" , PROFESSIONAL =""  }  } = constants["default"];
    const HOME_OWNER_TAB = startCase_default()(HOME_OWNER);
    const PROFESSIONAL_TAB = startCase_default()(PROFESSIONAL);
    const { brand  } = (0,useSearchi18n/* default */.Z)({});
    (0,react.useEffect)(()=>{
        if (activeTab === HOME_OWNER_TAB) {
            setHomeOwnerData(userData);
        } else {
            setProfessionalData(userData);
        }
    }, [
        userData
    ]);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then((config)=>{
            var ref;
            const langCode = (0,helper/* getLangCode */.pDj)(config);
            const siteName = config === null || config === void 0 ? void 0 : (ref = config.general) === null || ref === void 0 ? void 0 : ref.siteName;
            setSiteName(siteName);
            setLangCode(langCode);
        });
    }, []);
    const [installed, setInstalled] = (0,react.useState)({
        active: true,
        helpTopic: "",
        productType: "",
        modelNumber: "",
        serial: "",
        purchase: "",
        installDate: ""
    });
    const [professional, setProfessional] = (0,react.useState)({
        active: true,
        company: ""
    });
    const [requestMessage, setRequestMessage] = (0,react.useState)("");
    const [imageFiles, setImageFiles] = (0,react.useState)([]);
    const [loading, setLoading] = (0,react.useState)(false);
    const [formError, setFormError] = (0,react.useState)("");
    const [count, setCount] = (0,react.useState)(0);
    const [langCode, setLangCode] = (0,react.useState)("en-US");
    const [siteName, setSiteName] = (0,react.useState)(null);
    const { i18n ={} , submitSuccess =false , setActiveTab =()=>{} , activeTab ="" , clearModelSuggestions =()=>{} , businessTypes =[] , sourceKey ="" , handleSubmitMsg =()=>{} , showToaster =()=>{} , helpTopic =[] , productTypes =[] , getModelNumberSuggestions =()=>{} , modelSuggestions =[] , placeOfPurchase =[] , invalidModelNumber =false , authorData ={} , legalPages ={} , continueShoppingUrl =""  } = props;
    const contactInfoLabels = {
        zipCodeLabel: authorData === null || authorData === void 0 ? void 0 : authorData.zipCodeLabel,
        stateLabel: authorData === null || authorData === void 0 ? void 0 : authorData.stateLabel
    };
    const validateExist = async (field)=>{
        switch(field){
            case "fname":
            case "lname":
                var ref;
                if (!((ref = userData[field]) === null || ref === void 0 ? void 0 : ref.trim()) || !await (0,helper/* validateField */.OP$)("name", userData[field])) {
                    return field === "fname" ? i18n === null || i18n === void 0 ? void 0 : i18n.fnameError : i18n === null || i18n === void 0 ? void 0 : i18n.lnameError;
                }
                break;
            case "email":
                if (!userData[field]) return i18n === null || i18n === void 0 ? void 0 : i18n.noEmailError;
                else if (!await (0,helper/* validateField */.OP$)("email", userData[field])) return i18n === null || i18n === void 0 ? void 0 : i18n.validEmail;
                break;
            case "cemail":
                if (!userData[field]) return i18n === null || i18n === void 0 ? void 0 : i18n.noEmailError;
                else if (!await (0,helper/* validateField */.OP$)("email", userData[field])) return i18n === null || i18n === void 0 ? void 0 : i18n.validEmail;
                else if ((userData === null || userData === void 0 ? void 0 : userData.email) !== (userData === null || userData === void 0 ? void 0 : userData.cemail)) return i18n === null || i18n === void 0 ? void 0 : i18n.emailMatchError;
                break;
            case "phone":
                if (!(userData === null || userData === void 0 ? void 0 : userData.phone)) return i18n === null || i18n === void 0 ? void 0 : i18n.noPhoneError;
                else if (!(0,helperV2/* validateUSPhone */.ix)(userData === null || userData === void 0 ? void 0 : userData.phone)) return i18n === null || i18n === void 0 ? void 0 : i18n.validUSPhone;
                break;
            case "address":
                var ref1;
                if (!(userData === null || userData === void 0 ? void 0 : (ref1 = userData.address) === null || ref1 === void 0 ? void 0 : ref1.trim())) return i18n === null || i18n === void 0 ? void 0 : i18n.addressError;
                break;
            case "city":
                var ref2;
                if (!(userData === null || userData === void 0 ? void 0 : (ref2 = userData.city) === null || ref2 === void 0 ? void 0 : ref2.trim())) return i18n === null || i18n === void 0 ? void 0 : i18n.cityError;
                break;
            case "state":
                if (!(userData === null || userData === void 0 ? void 0 : userData.state) || isEmpty_default()(userData === null || userData === void 0 ? void 0 : userData.state)) return i18n === null || i18n === void 0 ? void 0 : i18n.stateError;
                break;
            case "zipcode":
                if (!userData.zipcode.trim()) return i18n.zipcodeError;
                else if (userData.zipcode.length < 5) return i18n.validZipcode;
                break;
            case "installDate":
                if (!(installed === null || installed === void 0 ? void 0 : installed.installDate)) return i18n === null || i18n === void 0 ? void 0 : i18n.installationDateValidError;
                break;
            case "company":
                if (!(userData === null || userData === void 0 ? void 0 : userData.company)) return i18n === null || i18n === void 0 ? void 0 : i18n.noCompanyError;
                break;
            case "businessType":
                if (!(userData === null || userData === void 0 ? void 0 : userData.businessType) || isEmpty_default()(userData === null || userData === void 0 ? void 0 : userData.businessType)) return i18n === null || i18n === void 0 ? void 0 : i18n.businessTypeError;
                break;
            case "subType":
                if (!(userData === null || userData === void 0 ? void 0 : userData.subType)) return i18n === null || i18n === void 0 ? void 0 : i18n.subTypeError;
                break;
            case "helpTopic":
                if (!(installed === null || installed === void 0 ? void 0 : installed.active) && (!(installed === null || installed === void 0 ? void 0 : installed.helpTopic) || isEmpty_default()(installed === null || installed === void 0 ? void 0 : installed.helpTopic))) return i18n === null || i18n === void 0 ? void 0 : i18n.helpTopic;
                break;
            case "productType":
                if ((installed === null || installed === void 0 ? void 0 : installed.active) && (!(installed === null || installed === void 0 ? void 0 : installed.productType) || isEmpty_default()(installed === null || installed === void 0 ? void 0 : installed.productType))) return i18n === null || i18n === void 0 ? void 0 : i18n.productType;
                break;
            default:
                return;
        }
    };
    const onSuggestionSelect = (val)=>{
        setInstalled({
            ...installed,
            modelNumber: val
        });
        clearModelSuggestions();
    };
    const onBlurError = async (field)=>{
        setError({
            ...error,
            [field]: await validateExist(field)
        });
    };
    const radioKeyDown = (e)=>{
        const { target: radioTarget = {} , key: radioKey = ""  } = e;
        const { nextSibling , previousSibling  } = radioTarget;
        const nextRadio = nextSibling;
        const previousRadio = previousSibling;
        if (radioKey === "ArrowLeft" && previousRadio) {
            previousRadio === null || previousRadio === void 0 ? void 0 : previousRadio.focus();
        } else if (radioKey === "ArrowRight" && nextRadio) {
            nextRadio === null || nextRadio === void 0 ? void 0 : nextRadio.focus();
        } else if (radioKey === "Enter" || radioKey === " ") {
            e === null || e === void 0 ? void 0 : e.preventDefault();
            radioTarget === null || radioTarget === void 0 ? void 0 : radioTarget.click();
        }
    };
    const getErrorList = async ()=>{
        const errorList = {
            fname: await validateExist("fname"),
            lname: await validateExist("lname"),
            email: await validateExist("email"),
            cemail: await validateExist("cemail"),
            address: await validateExist("address"),
            city: await validateExist("city"),
            state: await validateExist("state"),
            zipcode: await validateExist("zipcode"),
            phone: await validateExist("phone"),
            helpTopic: await validateExist("helpTopic"),
            productType: await validateExist("productType")
        };
        if (activeTab === PROFESSIONAL_TAB) {
            var ref, ref1, ref2;
            errorList.company = await validateExist("company");
            errorList.businessType = await validateExist("businessType");
            const subTypeList = !(errorList === null || errorList === void 0 ? void 0 : errorList.businessType) ? (ref2 = (ref = businessTypes === null || businessTypes === void 0 ? void 0 : businessTypes.find((el)=>{
                return el.text === (userData === null || userData === void 0 ? void 0 : userData.businessType);
            })) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.split(",")) === null || ref2 === void 0 ? void 0 : ref2.filter((e)=>e) : [];
            if ((subTypeList === null || subTypeList === void 0 ? void 0 : subTypeList.length) > 0 && !(userData === null || userData === void 0 ? void 0 : userData.subType)) {
                errorList.subType = i18n === null || i18n === void 0 ? void 0 : i18n.subTypeError;
            }
        }
        return errorList;
    };
    const onSubmit = async ()=>{
        var ref;
        setLoading(true);
        const errorDataList = [];
        const errorList = await getErrorList();
        const imageLinks = imageFiles === null || imageFiles === void 0 ? void 0 : imageFiles.map((image)=>{
            return {
                link: image === null || image === void 0 ? void 0 : image.link,
                comment: image === null || image === void 0 ? void 0 : image.comment
            };
        });
        setError(errorList);
        if (errorList === null || errorList === void 0 ? void 0 : errorList.fname) {
            errorDataList.push("contact-user-fname");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.lname) {
            errorDataList.push("contact-user-lname");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.email) {
            errorDataList.push("contact-user-email");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.cemail) {
            errorDataList.push("contact-user-cemail");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.address) {
            errorDataList.push("contact-user-address");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.city) {
            errorDataList.push("contact-user-city");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.state) {
            errorDataList.push("contact-user-state");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.zipcode) {
            errorDataList.push("contact-user-zipcode");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.phone) {
            errorDataList.push("contact-user-phone");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.helpTopic) {
            errorDataList.push("contact-installed-helpTopic");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.company) {
            errorDataList.push("contact-user-company");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.businessType) {
            errorDataList.push("contact-form-businessType");
        } else if (errorList === null || errorList === void 0 ? void 0 : errorList.productType) {
            errorDataList.push("contact-installed-productTypes");
        }
        errorDataList.forEach((item, i)=>{
            var ref;
            if (i === 0) (ref = document.getElementById("".concat(item))) === null || ref === void 0 ? void 0 : ref.focus();
        });
        const isInvalid = (ref = Object.values(errorList)) === null || ref === void 0 ? void 0 : ref.find((el)=>el);
        if (!isInvalid) {
            const { fname , lname , email , address , aptFloor , city , state , zipcode , country , phone , company , businessType , subType  } = userData;
            const body = {
                FirstName: fname,
                LastName: lname,
                Email: email,
                Address1: address,
                Address2: aptFloor,
                City: city,
                StateProvince: state === null || state === void 0 ? void 0 : state.code,
                PostalCode: zipcode,
                Country: country === null || country === void 0 ? void 0 : country.code,
                Phone: phone,
                AttachmentLinks: imageLinks,
                CustomerType: activeTab,
                InteractionType: "ContactUs",
                QuestionAboutInstalledProduct: installed === null || installed === void 0 ? void 0 : installed.active,
                DescribeYourRequest: requestMessage,
                SourceKey: [
                    {
                        Type: sourceKey,
                        Value: "".concat((0,helper/* getRandom */.sZz)()),
                        CreateDate: new Date().toISOString(),
                        UpdateDate: new Date().toISOString()
                    }
                ],
                Website: sourceKey,
                ...siteName !== brand ? {
                    LangCode: langCode
                } : {}
            };
            if (activeTab === PROFESSIONAL_TAB) {
                body["Company"] = company;
                body["BusinessType"] = businessType;
                body["BusinessSubtype"] = subType;
            }
            if (activeTab === HOME_OWNER_TAB && (professional === null || professional === void 0 ? void 0 : professional.active)) {
                body["WorkingWithAnotherProfessional"] = professional === null || professional === void 0 ? void 0 : professional.active;
                if (professional === null || professional === void 0 ? void 0 : professional.active) body["OtherProfessionalCompany"] = professional === null || professional === void 0 ? void 0 : professional.company;
            }
            if (installed === null || installed === void 0 ? void 0 : installed.active) {
                var ref1, ref2;
                body["ProductType"] = installed === null || installed === void 0 ? void 0 : installed.productType;
                body["PlaceOfPurchaseType"] = installed === null || installed === void 0 ? void 0 : installed.purchase;
                body["InstallationDate"] = installed === null || installed === void 0 ? void 0 : installed.installDate;
                body["ProductSerialNumber"] = installed === null || installed === void 0 ? void 0 : installed.serial;
                body["ModelNumber"] = (installed === null || installed === void 0 ? void 0 : (ref1 = installed.modelNumber) === null || ref1 === void 0 ? void 0 : ref1.startsWith("K-")) ? installed === null || installed === void 0 ? void 0 : (ref2 = installed.modelNumber) === null || ref2 === void 0 ? void 0 : ref2.slice(2) : installed === null || installed === void 0 ? void 0 : installed.modelNumber;
            } else {
                body["TopicSelected"] = installed === null || installed === void 0 ? void 0 : installed.helpTopic;
            }
            (0,helper/* sanitizeObject */.O0b)(body);
            (0,ReCaptcha/* validateRecaptcha */.L)().then((res)=>{
                if (res === null || res === void 0 ? void 0 : res.success) {
                    api/* apim.post */.TH.post(constants.CONTACT_US_VALIDATE_RECAPTCHA_ENDPOINT, body).then(()=>{
                        handleSubmitMsg(true);
                        addFormAnalyticsData(activeTab, submitSuccess, "", true);
                        setTimeout(()=>{
                            setActiveTab(HOME_OWNER_TAB);
                        }, 0);
                    }).catch((err)=>{
                        setFormError(i18n === null || i18n === void 0 ? void 0 : i18n.serverError);
                        addFormAnalyticsData(activeTab, submitSuccess, i18n === null || i18n === void 0 ? void 0 : i18n.serverError);
                        setLoading(false);
                        // eslint-disable-next-line no-console
                        console.log(err);
                    });
                } else {
                    setLoading(false);
                    addFormAnalyticsData(activeTab, submitSuccess, i18n === null || i18n === void 0 ? void 0 : i18n.genError);
                    showToaster(i18n === null || i18n === void 0 ? void 0 : i18n.genError);
                }
            });
        } else {
            setLoading(false);
            const allErrors = [];
            for(const key in errorList){
                if (errorList[key]) {
                    var ref3;
                    allErrors === null || allErrors === void 0 ? void 0 : allErrors.push((ref3 = errorList[key]) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase());
                }
            }
            addFormAnalyticsData(activeTab, submitSuccess, allErrors === null || allErrors === void 0 ? void 0 : allErrors.join("|"));
        }
    };
    const checkDisabled = (userdata)=>{
        var ref, ref1, ref2, ref3, ref4;
        if ((userdata === null || userdata === void 0 ? void 0 : (ref = userdata.fname) === null || ref === void 0 ? void 0 : ref.trim()) && (userdata === null || userdata === void 0 ? void 0 : (ref1 = userdata.lname) === null || ref1 === void 0 ? void 0 : ref1.trim()) && (userdata === null || userdata === void 0 ? void 0 : (ref2 = userdata.email) === null || ref2 === void 0 ? void 0 : ref2.trim()) && (userdata === null || userdata === void 0 ? void 0 : (ref3 = userdata.address) === null || ref3 === void 0 ? void 0 : ref3.trim()) && (userdata === null || userdata === void 0 ? void 0 : (ref4 = userdata.city) === null || ref4 === void 0 ? void 0 : ref4.trim()) && (userdata === null || userdata === void 0 ? void 0 : userdata.state) && (userdata === null || userdata === void 0 ? void 0 : userdata.country) && (userdata === null || userdata === void 0 ? void 0 : userdata.phone) && ((installed === null || installed === void 0 ? void 0 : installed.active) ? installed === null || installed === void 0 ? void 0 : installed.productType : installed === null || installed === void 0 ? void 0 : installed.helpTopic)) return false;
        return true;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((index_module_default()) === null || (index_module_default()) === void 0 ? void 0 : (index_module_default()).contactUsStyleWrapper),
        children: !submitSuccess ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "kf-react-container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "contact-us-main",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "title",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "question",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.contactInformation
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "required-fields",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.requiredInfoText
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_FormTabs, {
                        label: [
                            HOME_OWNER_TAB,
                            PROFESSIONAL_TAB
                        ],
                        customClass: "gbh-data-layer",
                        analyticsData: '{"eventAction":"support:contact:form:{?}","eventName":"support:contact:form:{?}","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"{?}","internalLinkPosition":"contact us","internalLinkType":"support:contact:contact information","internalLinkZoneName":"support:contact:form","internalLinkURL":"n/a","clickInternalLinks":"true"}',
                        activeTab: activeTab,
                        i18n: i18n,
                        changeActive: (l)=>{
                            setActiveTab(l);
                            setUserData(l === HOME_OWNER_TAB ? homeOwnerData : professionalData);
                            setError({});
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_ContactInfo, {
                        activeTab: activeTab,
                        data: userData,
                        labels: contactInfoLabels,
                        setData: setUserData,
                        error: error,
                        i18n: i18n,
                        businessTypes: businessTypes,
                        onBlur: onBlurError,
                        setError: setError
                    }, activeTab),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_ProductInstalled, {
                        i18n: i18n,
                        data: installed,
                        setData: setInstalled,
                        error: error,
                        helpTopic: helpTopic,
                        productTypes: productTypes,
                        getModelNumberSuggestions: getModelNumberSuggestions,
                        modelSuggestions: modelSuggestions,
                        onSuggestionSelect: onSuggestionSelect,
                        placeOfPurchase: placeOfPurchase,
                        onBlur: onBlurError,
                        findingModel: props.findingModel,
                        radioKeyDown: radioKeyDown,
                        invalidModelNumber: invalidModelNumber,
                        setError: setError,
                        authorData: authorData
                    }),
                    activeTab === HOME_OWNER_TAB && /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_WithProfessional, {
                        i18n: i18n,
                        data: professional,
                        setData: setProfessional,
                        radioKeyDown: radioKeyDown
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "optional-form",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                id: "contactus-request-message",
                                className: "question",
                                children: [
                                    i18n === null || i18n === void 0 ? void 0 : i18n.describeYourRequest,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "description",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.requestDetail
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (TextArea_index_module_default()).wrapper,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "form-wrapper textarea__wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                            className: "textarea-message",
                                            id: "requestMessage",
                                            "aria-labelledby": "contactus-request-message",
                                            value: requestMessage,
                                            placeholder: "Message",
                                            onChange: async (e)=>{
                                                const { value  } = e.target;
                                                if (await (0,helper/* validateField */.OP$)("contactusMessage", value) || value === "") {
                                                    setCount(value === null || value === void 0 ? void 0 : value.length);
                                                    setRequestMessage(value);
                                                }
                                            },
                                            maxLength: "500"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            "aria-hidden": "true",
                                            className: "textare-label-message",
                                            children: i18n === null || i18n === void 0 ? void 0 : i18n.messageLabel
                                        }),
                                        count !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "contact-us-count",
                                            children: [
                                                count,
                                                "/500"
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "optional-form border-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "question",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadPhoto
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "description",
                                children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadCountLimit
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "upload-notes",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadFileTypes
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadFileExtn
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "upload-notes",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadSizeLimit
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.uploadMBLimit
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_UploadImage, {
                                imageList: imageFiles,
                                updateList: setImageFiles,
                                i18n: i18n,
                                activeTab: activeTab,
                                buttonAnalyticsData: contactUsViewAnalytics_getAnalyticsData(activeTab, formError, submitSuccess, false)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "contact-us-footer",
                        children: [
                            formError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "contact-us-footer__error-msg",
                                children: formError
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                role: "button",
                                id: "submit-contact-form-button",
                                disabled: checkDisabled(userData),
                                onClick: onSubmit,
                                type: "black",
                                label: i18n === null || i18n === void 0 ? void 0 : i18n.submitButton,
                                flexible: true,
                                loading: loading,
                                useDefaultClass: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptcha/* default */.Z, {
                                getAnalyticsData: getRecaptchaAnalytics
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "contact-us__policies",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: legalPages === null || legalPages === void 0 ? void 0 : legalPages.privacyPolicy,
                                        "data-gbh-data-layer": getFooterEventInfo("privacy policy", legalPages === null || legalPages === void 0 ? void 0 : legalPages.privacyPolicy),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: (e)=>{
                                            return (0,helper/* getSiteWideModal */.Ure)(e, legalPages === null || legalPages === void 0 ? void 0 : legalPages.privacyPolicy);
                                        },
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.privacyPolicy
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: legalPages === null || legalPages === void 0 ? void 0 : legalPages.subjectAccessRequest,
                                        "data-gbh-data-layer": getFooterEventInfo("subject access request", legalPages === null || legalPages === void 0 ? void 0 : legalPages.subjectAccessRequest, "false"),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: (e)=>{
                                            return (0,helper/* getSiteWideModal */.Ure)(e, legalPages === null || legalPages === void 0 ? void 0 : legalPages.subjectAccessRequest);
                                        },
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.subjectAccessRequest
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: legalPages === null || legalPages === void 0 ? void 0 : legalPages.termsOfService,
                                        "data-gbh-data-layer": getFooterEventInfo("terms of service", legalPages === null || legalPages === void 0 ? void 0 : legalPages.termsOfService),
                                        target: "_blank",
                                        rel: "noreferrer",
                                        onClick: (e)=>{
                                            return (0,helper/* getSiteWideModal */.Ure)(e, legalPages === null || legalPages === void 0 ? void 0 : legalPages.termsOfService);
                                        },
                                        children: i18n === null || i18n === void 0 ? void 0 : i18n.termsOfService
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "contact-us__success-message-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(v1_ContactUsConfirmation, {
                i18n: i18n,
                setSubmitSuccess: handleSubmitMsg,
                continueShoppingUrl: continueShoppingUrl
            })
        })
    });
};
/* harmony default export */ var ContactUsView = ((0,lib/* withOrientationChange */.Qe)(ContactUs));

;// CONCATENATED MODULE: ./components/ContactUs/v1/ContactUs.jsx














const ContactUs_ContactUs = (props)=>{
    const { data: componentProp  } = props;
    const { type: sourceKeyType = "" , continueShoppingUrl =""  } = componentProp;
    const { CREATE_ACCOUNT_TYPE: { HOME_OWNER =""  }  } = constants["default"];
    const [activeTab, setActiveTabVal] = (0,react.useState)(startCase_default()(HOME_OWNER));
    const [helpTopic, setHelpTopic] = (0,react.useState)([]);
    const [productTypes, setProductTypes] = (0,react.useState)([]);
    const [placeOfPurchase, setPlaceOfPurchase] = (0,react.useState)([]);
    const [businessTypes, setBusinessTypes] = (0,react.useState)([]);
    const [modelSuggestions, setModelSuggestions] = (0,react.useState)([]);
    const [invalidModelNumber, setInvalidModelNumber] = (0,react.useState)(false);
    const [submitSuccess, setSubmitSuccess] = (0,react.useState)(false);
    const [homePagePath, setHomePagePath] = (0,react.useState)();
    const [legalPageLinks, setLegalPageLinks] = (0,react.useState)();
    const [continueShoppingUrlData, setContinueShoppingUrlData] = (0,react.useState)("");
    const i18n = i18n_useContactUsi18n(componentProp);
    const dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(()=>{
        dispatch((0,genericSlice/* getGenericListPath */.Ln)());
    }, []);
    (0,react.useEffect)(()=>{
        (0,constants_config/* getConfig */.i)().then(async (config)=>{
            const homePagePath = await (0,helper/* getShortenedUrl */.Ppy)(get_default()(config, "general.homepageUrl", "/"));
            const legalPageLinks = get_default()(config, "legalPageData.map", {});
            setHomePagePath(homePagePath);
            setLegalPageLinks(legalPageLinks);
            setContinueShoppingUrlData(await (0,helper/* getShortenedUrl */.Ppy)(continueShoppingUrl || ""));
        });
    });
    (0,react.useEffect)(()=>{
        if (isEmpty_default()(helpTopic) || isEmpty_default()(productTypes) || isEmpty_default()(placeOfPurchase) || isEmpty_default()(businessTypes)) getListItem();
    }, [
        helpTopic,
        productTypes,
        placeOfPurchase,
        businessTypes
    ]);
    const handleSubmit = (status)=>{
        const container = document.getElementById("aem-contact-us-container");
        status ? container === null || container === void 0 ? void 0 : container.classList.add("d-none") : container === null || container === void 0 ? void 0 : container.classList.remove("d-none");
        setSubmitSuccess(status);
    };
    const getListItem = async ()=>{
        var ref, ref1, ref2, ref3, ref4, ref5;
        const { payload: commonList  } = await dispatch((0,genericSlice/* getCommonList */.m8)());
        const { payload: businessType  } = await dispatch((0,genericSlice/* getBusinessList */.Dz)());
        setHelpTopic((ref = commonList === null || commonList === void 0 ? void 0 : commonList.find((el)=>{
            return (el === null || el === void 0 ? void 0 : el.text) === "helpTopic";
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.value) === null || ref1 === void 0 ? void 0 : ref1.split(","));
        setProductTypes((ref2 = commonList === null || commonList === void 0 ? void 0 : commonList.find((el)=>{
            return (el === null || el === void 0 ? void 0 : el.text) === "productTypes";
        })) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.value) === null || ref3 === void 0 ? void 0 : ref3.split(","));
        setPlaceOfPurchase((ref4 = commonList === null || commonList === void 0 ? void 0 : commonList.find((el)=>{
            return (el === null || el === void 0 ? void 0 : el.text) === "placeOfPurchase";
        })) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.value) === null || ref5 === void 0 ? void 0 : ref5.split(","));
        setBusinessTypes(businessType);
    };
    const modelNumberSuggestions = async (searchKeyword)=>{
        var ref;
        const config = await (0,constants_config/* getConfig */.i)();
        var ref1;
        const language = (ref1 = config === null || config === void 0 ? void 0 : (ref = config.internationalization) === null || ref === void 0 ? void 0 : ref.language) !== null && ref1 !== void 0 ? ref1 : "en";
        const params = {
            q: searchKeyword,
            rows: 10,
            fq: [
                'language_s:("'.concat(language, '")'),
                '-Brand_ss:("PlumbingServiceParts")'
            ],
            fl: "variantList.sku_ss,customerFacingSKUList_ss,Brand_ss,Country_ss",
            start: 0,
            skuSearch: true
        };
        const { suggestions =[] , invalidModelNumber =false  } = await dispatch((0,myProductSlice/* getModelNumberSuggest */.u8)(params)).unwrap();
        setModelSuggestions(suggestions);
        setInvalidModelNumber(invalidModelNumber);
    };
    const getModelNumberSuggestions = debounce_default()((key)=>modelNumberSuggestions(key), 500);
    const clearModelSuggestions = ()=>setModelSuggestions([]);
    const setActiveTab = (t)=>{
        setActiveTabVal(t);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactUsView, {
        i18n: i18n,
        helpTopic: helpTopic,
        productTypes: productTypes,
        placeOfPurchase: placeOfPurchase,
        businessTypes: businessTypes,
        sourceKey: sourceKeyType,
        continueShoppingUrl: continueShoppingUrlData,
        invalidModelNumber: invalidModelNumber,
        modelSuggestions: modelSuggestions,
        getModelNumberSuggestions: getModelNumberSuggestions,
        clearModelSuggestions: clearModelSuggestions,
        showToaster: (msg)=>(0,genericSlice/* showToast */.CF)({
                message: msg,
                isVisible: true
            }),
        homePagePath: homePagePath,
        submitSuccess: submitSuccess,
        handleSubmitMsg: handleSubmit,
        legalPages: legalPageLinks,
        setActiveTab: setActiveTab,
        activeTab: activeTab,
        authorData: componentProp
    }, submitSuccess);
};
/* harmony default export */ var v1_ContactUs = (ContactUs_ContactUs);


/***/ }),

/***/ 3282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29238);
/* harmony import */ var isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2595);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55760);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96301);







const BreadCrumb = (props)=>{
    const { data: { appliedCssClassNames ="" , items =[]  } , fullData ={}  } = props;
    const { carousel: { carouselComponentProperties: { appliedCssClassNames: carouselClassName = ""  } = {}  } = {}  } = fullData;
    const isSsr = (0,_hooks_useIsSsr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    const [eventPageName, setEventPageName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [shortURLs, setShortURLs] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [componentGroup, setComponentGroup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [columnClassNames, setColumnClassNames] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const urls = items.map((navItem)=>navItem.url);
        Promise.all(urls.map(_utils_helper__WEBPACK_IMPORTED_MODULE_5__/* .getShortenedUrl */ .Ppy)).then((res)=>setShortURLs(res));
    }, [
        items
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isSsr) return;
        setEventPageName(window.eventPageType);
    }, [
        isSsr
    ]);
    // #ToDo Hard coding zone value once received data from json will change
    const zone = "hero banner";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_3___default()(fullData)) {
            Object.keys(fullData).forEach((key)=>{
                setComponentGroup((cmpGroup)=>[
                        ...cmpGroup,
                        fullData[key][":type"]
                    ]);
            });
        }
    }, [
        fullData
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (componentGroup.length > 0) {
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.TEASER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CAROUSEL);
            }) && carouselClassName === "carousel-navigation-cta-left-right") {
                setColumnClassNames((className)=>className += " breadcrumb-overlay");
            }
            if (componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.BREADCRUMB);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CAROUSEL);
            }) && componentGroup.find((a)=>{
                return a === null || a === void 0 ? void 0 : a.includes(_constants__WEBPACK_IMPORTED_MODULE_6__.COMPONENT_TYPES.CONTAINER);
            }) && !(columnClassNames === null || columnClassNames === void 0 ? void 0 : columnClassNames.includes("aem-GridColumn aem-GridColumn--default--12"))) {
                setColumnClassNames((className)=>className += " aem-GridColumn aem-GridColumn--default--12");
            }
        }
    }, [
        componentGroup
    ]);
    const getEventInfo = (navItem, index)=>{
        if (isSsr) {
            return JSON.stringify({
                clickInternalLinks: "true",
                eventAction: eventPageName + ":" + zone + ":breadcrumb",
                eventName: eventPageName + ":" + zone + ":breadcrumb",
                eventType: eventPageName,
                internalLinkName: navItem === null || navItem === void 0 ? void 0 : navItem.title,
                internalLinkPosition: "main content area",
                internalLinkType: window.storeLinkType ? window.storeLinkType : eventPageName + ":breadcrumb",
                internalLinkURL: navItem === null || navItem === void 0 ? void 0 : navItem.url,
                internalLinkZoneName: eventPageName + ":" + zone
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "breadcrumb breadcrumb-links ".concat(appliedCssClassNames ? appliedCssClassNames : "").concat(columnClassNames),
            children: items.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                id: "breadcrumb",
                className: "cmp-breadcrumb",
                "aria-label": "Breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: "cmp-breadcrumb__list",
                    itemScope: true,
                    children: items.map((navItem, index)=>{
                        const isLastItem = index === items.length - 1;
                        const isActive = navItem.active;
                        const shouldRenderSlash = !isActive && !isLastItem && !items[index + 1].active;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            className: "cmp-breadcrumb__item".concat(navItem.active ? " cmp-breadcrumb__item--active" : ""),
                            itemProp: "itemListElement",
                            itemScope: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: shortURLs[index],
                                    className: "cmp-breadcrumb__item-link",
                                    itemProp: "item",
                                    "data-zone": zone,
                                    "aria-label": navItem.title,
                                    "aria-current": navItem.active || isLastItem ? "page" : null,
                                    "data-gbh-data-layer": !isSsr && getEventInfo(navItem, index),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        itemProp: "name",
                                        dangerouslySetInnerHTML: {
                                            __html: isomorphic_dompurify__WEBPACK_IMPORTED_MODULE_2___default().sanitize(navItem === null || navItem === void 0 ? void 0 : navItem.title)
                                        }
                                    })
                                }),
                                " ",
                                shouldRenderSlash && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "cmp-breadcrumb-slash",
                                            "aria-hidden": "true"
                                        }),
                                        "\xa0"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                    itemProp: "position",
                                    content: index + 1
                                })
                            ]
                        }, "breadcrumb-item-".concat(index));
                    })
                })
            }) : null
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BreadCrumb);


/***/ }),

/***/ 787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const KnowledgeArticleFiller = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "kf-react-plp-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "kf-page-title",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer mb-20"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "kf-page-title__separator"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-250",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "shimmer-loading__para shimmer "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "shimmer-loading__para shimmer "
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "kf-page-title__total",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "shimmer-loading__para shimmer width-full"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "kf-react-plp-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "kf-page-title",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer mb-20"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "kf-page-title__separator"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-250",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "shimmer-loading__para shimmer "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "shimmer-loading__para shimmer "
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "kf-page-title__total",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "shimmer-loading__para shimmer width-full"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "kf-react-plp-container",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "kf-page-title",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer mb-20"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "kf-page-title__title shimmer-loading__title shimmer"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "kf-page-title__separator"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "width-250",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "shimmer-loading__para shimmer "
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "shimmer-loading__para shimmer "
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "kf-page-title__total",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "shimmer-loading__para shimmer width-full"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (KnowledgeArticleFiller);


/***/ }),

/***/ 32979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactUsStyleWrapper":"ContactUsView_contactUsStyleWrapper__c_7iV"};

/***/ })

}]);